import { AdminShieldIcon } from '@/components/common/icons'
import { Label } from '../label'

export const AdminBadge = () => (
  <div>
    <AdminShieldIcon width={28} height={32} />
    <Label css={{ ml: '$4' }}>Branch Only</Label>
  </div>
)
